import { searchSwitchViewClick } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import TextButton from 'LuxKit/Button/TextButton'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import noop from 'lib/function/noop'

interface Props {
  mapViewURL: string
  onClick?: () => void
}

const StyledGroup = styled(Group)`
  background-image: url(${getSVGImageUrl('lebt-map-view-background-full')});
  background-position: center left;
  /* need to zoom in on the image */
  background-size: 150%;
  height: ${rem(80)};

  [dir='rtl'] & {
    background-position: center right;
  }

  ${mediaQueryUp.tablet} {
    height: ${rem(90)};
  }
`

function MapWindow(props: Props) {
  const { mapViewURL, onClick = noop } = props
  const intl = useIntl()

  function handleClick() {
    onClick()
    addGTMEvent(searchSwitchViewClick())
  }

  return (
    <ClickableLink to={mapViewURL} onClick={handleClick}>
      <StyledGroup direction="horizontal" horizontalAlign="center" verticalAlign="center">
        <TextButton
          kind="primary"
          variant="dark"
          startIcon={<LineMapIcon />}
        >
          {intl.formatMessage({
            id: 'HXvVOiFJntO-oshArxXc',
            defaultMessage: 'View on map',
            description: 'Button text to switch to map view of search results',
          })}
        </TextButton>
      </StyledGroup>
    </ClickableLink>
  )
}

export default MapWindow
